import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import uniq from 'lodash/uniq';
import isString from 'lodash/isString';
import get from 'lodash/get';
import set from 'lodash/set';

const ITEMS_TO_MATCH = [
  'Address.street',
  'Address.street2',
  'Address.city',
  'Address.zipcode',
  'Address.state',
  'Address.country',
  'Employer.value',
  'Dates.from.month',
  'Dates.from.year',
  'Dates.to.month',
  'Dates.to.year',
  'Dates.present',
  'Supervisor.SupervisorName.value'
];

const requiredFieldsHaveValues = (obj: any) => [
  'Employer.value',
  'Dates.from.month',
  'Dates.from.year',
  'Dates.to.month',
  'Dates.to.year',
  'Supervisor.SupervisorName.value'
].every((field) => !!(get(obj, field)));

export const getSpecificFieldsInObject = (obj: any) => {
  const newObj = pick(obj, ITEMS_TO_MATCH);
  ITEMS_TO_MATCH.forEach((field) => {
    const value: any = get(newObj, field);
    if (isString(value)) {
      set(newObj, field, value.toLowerCase());
    }
  });
  return newObj;
};

export const getDuplicateItemsList = (items: any[]) => {
  const duplicateItems: number[] = [];
  if (items) {
    items.forEach(({ Item: Item1 }: any, index1: number) => {
      if (!requiredFieldsHaveValues(Item1)) { return; }
      const info1 = getSpecificFieldsInObject(Item1);
      items.forEach(({ Item: Item2 }: any, index2: number) => {
        if (index1 === index2 || !requiredFieldsHaveValues(Item2)) { return; }

        const info2 = getSpecificFieldsInObject(Item2);
        if (isEqual(info1, info2)) {
          duplicateItems.push(index1, index2);
        }
      });
    });
  }
  return uniq(duplicateItems);
};
